const calculateSignificantScrollDistance = _ref => {
  let {
    on,
    vpHeight,
    baseTop
  } = _ref;

  switch (on) {
    // this mode is activated immediately and relates to entire pages scroll
    case "load":
      // return the entire page's scroll distance.
      return Math.max(0, window.pageYOffset || document.documentElement.scrollTop);
    // once the target element enters (from the bottom of) the viewport,
    // start counting the scroll distance

    case "enter":
      return Math.max(0, vpHeight - baseTop);
    // once the target exits (to the top of) the viewport,
    // start counting the scroll distance

    default:
      return Math.max(0, 0 - baseTop);
  }
};

export default calculateSignificantScrollDistance;